import { createScopedI18n } from './createScopedI18n';

export function buildScopedI18n({ esCL, enUS, ptBR }, options = {}) {
  return createScopedI18n(
    {
      'es-CL': {
        translation: esCL,
      },
      'en-US': {
        translation: enUS,
      },
      'pt-BR': {
        translation: ptBR,
      },
    },
    options
  );
}
